"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Types = exports.StyledSubmitButton = exports.MAX_FILE_SIZE = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Button2 = require("../../../Button/Button");
var _Editor = _interopRequireDefault(require("../../../Editor"));
var _AttachmentList = _interopRequireDefault(require("../AttachmentList2"));
var _components = require("../../../Editor/components");
var _ActionPopup = _interopRequireDefault(require("../../Common/ActionPopup"));
var _Throbber = _interopRequireDefault(require("../../../Throbber"));
var _UserSelect = _interopRequireWildcard(require("../../Clients/UserSelect"));
var _Message = require("../Message2");
var _EmailTemplateForm = _interopRequireWildcard(require("../EmailTemplateForm/EmailTemplateForm"));
var _OverlayLoader = _interopRequireWildcard(require("../../../OverlayLoader"));
var _iconsReact = require("../../../../icons-react");
var _editor = require("../../../../icons-react/editor");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Types = exports.Types = {
  email: 'email',
  messenger: 'messenger'
};
var MAX_FILE_SIZE = exports.MAX_FILE_SIZE = Math.pow(10, 7);
var messengerFormLoaderStyles = {
  loaderColor: '#007AFF',
  loaderHeight: 8,
  loaderWidth: 8,
  backgroundColor: 'rgba(255, 255, 255, 1)'
};
var messengerFormEditorLoaderStyled = _objectSpread(_objectSpread({}, messengerFormLoaderStyles), {}, {
  zIndex: 10
});
var MessengerForm2 = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var values = _ref.values,
    buttonLabel = _ref.buttonLabel,
    type = _ref.type,
    subjectSuggestList = _ref.subjectSuggestList,
    defaultFromSuggest = _ref.defaultFromSuggest,
    fromSuggests = _ref.fromSuggests,
    isDisabledSubjectSelect = _ref.isDisabledSubjectSelect,
    isDisabledFromSelect = _ref.isDisabledFromSelect,
    isDisabledSubjectCopySelect = _ref.isDisabledSubjectCopySelect,
    isDisabledSubjectHideCopySelect = _ref.isDisabledSubjectHideCopySelect,
    isLoadingMailTemplate = _ref.isLoadingMailTemplate,
    isLoadingSuggests = _ref.isLoadingSuggests,
    isLoading = _ref.isLoading,
    isDisabledSubmit = _ref.isDisabledSubmit,
    buttonIsLoadingLabel = _ref.buttonIsLoadingLabel,
    onEmailInputChange = _ref.onEmailInputChange,
    onChangeSubjects = _ref.onChangeSubjects,
    onChangeSubjectsCopy = _ref.onChangeSubjectsCopy,
    onChangeSubjectsHideCopy = _ref.onChangeSubjectsHideCopy,
    onChangeFrom = _ref.onChangeFrom,
    onChangeBody = _ref.onChangeBody,
    onSubmit = _ref.onSubmit,
    onFocus = _ref.onFocus,
    width = _ref.width,
    emailTemplateGroup = _ref.emailTemplateGroup,
    emailTemplateColumns = _ref.emailTemplateColumns,
    onSubmitEmailTemplate = _ref.onSubmitEmailTemplate,
    onSelectRowEmailTemplate = _ref.onSelectRowEmailTemplate,
    onSelectGroupEmailTemplate = _ref.onSelectGroupEmailTemplate,
    className = _ref.className,
    from = _ref.from,
    subjectsCopy = _ref.subjectsCopy,
    subjectsHideCopy = _ref.subjectsHideCopy,
    isForwardingMessage = _ref.isForwardingMessage,
    forwardingMessage = _ref.forwardingMessage,
    isForwardingChain = _ref.isForwardingChain,
    forwardingChain = _ref.forwardingChain,
    activeChainTheme = _ref.activeChainTheme,
    onSetForwardingMessage = _ref.onSetForwardingMessage,
    onResetForwardingMessage = _ref.onResetForwardingMessage,
    onResetForwardingChain = _ref.onResetForwardingChain;
  var _useState = (0, _react.useState)(values.isOpenSubjectsCopy),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpenSubjectsCopy = _useState2[0],
    setIsOpenSubjectsCopy = _useState2[1];
  var _useState3 = (0, _react.useState)(values.isOpenSubjectsHideCopy),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isOpenSubjectsHideCopy = _useState4[0],
    setIsOpenSubjectsHideCopy = _useState4[1];
  var _useState5 = (0, _react.useState)(values.body),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    body = _useState6[0],
    setBody = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    forwardingMessageBody = _useState8[0],
    setForwardingMessageBody = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    attachments = _useState10[0],
    setAttachments = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    forwardAttachments = _useState12[0],
    setForwardAttachments = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    isOpenTemplateForm = _useState14[0],
    setIsOpenTemplateForm = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    isAttachmentSizeError = _useState16[0],
    setIsAttachmentSizeError = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    isOpenToolbar = _useState18[0],
    setIsOpenToolbar = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
    isManualControlToolbar = _useState20[0],
    setIsManualControlToolbar = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
    isDisabledEmailToSelect = _useState22[0],
    setIsDisabledEmailToSelect = _useState22[1];
  var _useState23 = (0, _react.useState)(values.subjects),
    _useState24 = (0, _slicedToArray2["default"])(_useState23, 2),
    subjects = _useState24[0],
    setSubjects = _useState24[1];
  var _useState25 = (0, _react.useState)(subjectsCopy),
    _useState26 = (0, _slicedToArray2["default"])(_useState25, 2),
    subjectsCopyValue = _useState26[0],
    setSubjectsCopyValue = _useState26[1];
  var _useState27 = (0, _react.useState)(subjectsHideCopy),
    _useState28 = (0, _slicedToArray2["default"])(_useState27, 2),
    subjectsHideCopyValue = _useState28[0],
    setSubjectsHideCopyValue = _useState28[1];
  var _useState29 = (0, _react.useState)("FWD: ".concat(activeChainTheme)),
    _useState30 = (0, _slicedToArray2["default"])(_useState29, 2),
    themeValue = _useState30[0],
    setThemeValue = _useState30[1];
  var isForwardingProcess = isForwardingChain || isForwardingMessage;
  var uploaderRef = (0, _react.useRef)(null);
  var imageUrls = values.imageUrl && [{
    name: 'Изображение шаблона.jpg',
    size: 0,
    url: values.imageUrl
  }];
  (0, _react.useEffect)(function () {
    setSubjectsCopyValue(subjectsCopy);
    setSubjectsHideCopyValue(subjectsHideCopy);
  }, [subjectsCopy, subjectsHideCopy]);
  var handleSubmit = (0, _react.useCallback)(function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    var submitParams = {
      attachments: attachments,
      body: body,
      subjects: subjects,
      imageUrl: values.imageUrl,
      from: from || defaultFromSuggest,
      subjectsCopy: subjectsCopy,
      subjectsHideCopy: subjectsHideCopy
    };
    if (isForwardingMessage) submitParams = _objectSpread(_objectSpread({}, submitParams), {}, {
      subject: themeValue,
      // передаем айдишники вложений, чтобы бэк их подсосал в новой цепочке
      forwardAttachments: forwardAttachments.map(function (at) {
        return at.id;
      }),
      messageId: forwardingMessage.id,
      body: forwardingMessageBody,
      comment: body
    });else if (isForwardingChain) submitParams = {
      subject: themeValue,
      chainId: forwardingChain,
      to: subjects.value,
      from: from || defaultFromSuggest,
      comment: body,
      subjectsCopy: subjectsCopy,
      subjectsHideCopy: subjectsHideCopy
    };
    console.log('handleSubmit: ', submitParams);
    onSubmit(submitParams);
    setAttachments([]);
  }, [body, type, values.imageUrl, subjects, attachments, subjectsCopy, subjectsHideCopy, from, defaultFromSuggest, onSubmit, isForwardingChain, isForwardingMessage, forwardAttachments, themeValue]);
  var handleSubjectsChange = (0, _react.useCallback)(function (data) {
    setSubjects(data);
    onChangeSubjects(data);
  }, [onChangeSubjects]);
  var handleEmailInputChange = (0, _react.useCallback)(function (suggestType) {
    return function (data) {
      onEmailInputChange(data, suggestType);
    };
  }, [onEmailInputChange]);
  var toggleIsOpenSubjectsCopy = (0, _react.useCallback)(function () {
    setIsOpenSubjectsCopy(function (prev) {
      return !prev;
    });
  });
  var toggleIsOpenSubjectsHideCopy = (0, _react.useCallback)(function () {
    setIsOpenSubjectsHideCopy(function (prev) {
      return !prev;
    });
  });
  var handleEditorChanges = (0, _react.useCallback)(function (editorBody) {
    if (editorBody !== body) {
      onChangeBody(editorBody);
    }
    setBody(editorBody);
  }, [onChangeBody]);

  // const handleForwardEditorChange = (forwardEditorBody) => {
  //   if (forwardEditorBody !== forwardingMessageBody) {
  //     onSetForwardingMessage({
  //       isForwarding: true,
  //       message: { ...forwardingMessage, text: forwardEditorBody },
  //     });
  //     setForwardingMessageBody(forwardEditorBody);
  //   }
  // };

  var handleForwardEditorChange = (0, _react.useCallback)(function (forwardEditorBody) {
    // if (forwardEditorBody !== forwardingMessageBody) {
    // onSetForwardingMessage({
    //   isForwarding: true,
    //   message: { ...forwardingMessage, text: forwardEditorBody },
    // });
    // }
    setForwardingMessageBody(forwardEditorBody);
  }, [onSetForwardingMessage]);
  var handleThemeChange = function handleThemeChange(newThemeValue) {
    setThemeValue(newThemeValue);
  };
  var handleUploading = (0, _react.useCallback)(function (event) {
    event.persist();
    event.preventDefault();
    event.stopPropagation();
    var isSizeError = false;
    Array.from(event.target.files).forEach(function (file) {
      if (file.size > MAX_FILE_SIZE) {
        isSizeError = true;
      }
    });
    if (!isSizeError) {
      setAttachments(function (prevAttachments) {
        return (0, _uniqBy2["default"])([].concat((0, _toConsumableArray2["default"])(prevAttachments), (0, _toConsumableArray2["default"])(event.target.files)));
      });
    } else {
      setIsAttachmentSizeError(true);
    }
  });
  var toggleIsAttachmentSizeError = (0, _react.useCallback)(function () {
    setIsAttachmentSizeError(function (prev) {
      return !prev;
    });
  });
  var toggleIsOpenTemplateForm = (0, _react.useCallback)(function () {
    setIsOpenTemplateForm(function (prev) {
      return !prev;
    });
  });
  var handleDeleteAttachment = (0, _react.useCallback)(function (lastModified) {
    setAttachments(function (prevAttachments) {
      return prevAttachments.filter(function (attachment) {
        return attachment.lastModified !== lastModified;
      });
    });
  });
  var handleDeleteForwardAttachment = (0, _react.useCallback)(function (id) {
    setForwardAttachments(function (prevAttachments) {
      return prevAttachments.filter(function (attachment) {
        return attachment.id !== id;
      });
    });
  });
  var triggerUploader = (0, _react.useCallback)(function () {
    if (uploaderRef.current) uploaderRef.current.click();
  });
  var handleSubmitAttachmentError = (0, _react.useCallback)(function () {
    triggerUploader();
    setIsAttachmentSizeError(false);
  });
  var handleFocus = (0, _react.useCallback)(function (ev) {
    ev.preventDefault();
    onFocus();
    if (isOpenToolbar || isManualControlToolbar) return;
    setIsOpenToolbar(true);
  }, [isOpenToolbar, isManualControlToolbar, onFocus]);
  var toggleToolbar = (0, _react.useCallback)(function () {
    setIsOpenToolbar(!isOpenToolbar);
    setIsManualControlToolbar(true);
  }, [isOpenToolbar]);
  var resetStates = function resetStates() {
    setSubjects(values.subjects);
    setSubjectsCopyValue(subjectsCopy);
    setSubjectsHideCopyValue(subjectsHideCopy);
    setThemeValue("FWD: ".concat(activeChainTheme));
  };
  (0, _react.useEffect)(function () {
    setBody(values.body);
  }, [values.body]);
  (0, _react.useEffect)(function () {
    if (forwardingMessage) {
      setForwardingMessageBody(forwardingMessage.text);
      setForwardAttachments(forwardingMessage.attachments || []);
    }
  }, [forwardingMessage]);
  (0, _react.useEffect)(function () {
    if (isDisabledSubjectSelect) setIsDisabledEmailToSelect(true);
    if (isForwardingProcess) {
      setIsDisabledEmailToSelect(false);
      var newSubject = {
        label: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 Email \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u0435\u0440\u0435\u0441\u043B\u0430\u0442\u044C ".concat(isForwardingChain ? 'цепочку' : 'сообщение'),
        value: ''
      };
      setSubjects(newSubject);
      setSubjectsCopyValue([]);
      setSubjectsHideCopyValue([]);
    }
    if (!isForwardingProcess) {
      resetStates();
    }
  }, [isDisabledSubjectSelect, isForwardingProcess]);
  var handleCancelForwarding = (0, _react.useCallback)(function () {
    // возвращаем предыдущие значения
    resetStates();
    if (isForwardingChain) onResetForwardingChain();
    if (isForwardingMessage) onResetForwardingMessage();
  });
  var isDisabledSubmitButton = isDisabledSubmit || isForwardingProcess && !(subjects !== null && subjects !== void 0 && subjects.value) || isForwardingChain && !themeValue;
  var linkButton = function linkButton() {
    return /*#__PURE__*/_react["default"].createElement(_components.LinkToolBar, null);
  };
  var attachmentButton = function attachmentButton() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledToolbarButton, {
      key: "attachmentButton",
      type: "button",
      onClick: triggerUploader
    }, /*#__PURE__*/_react["default"].createElement(StyledAttachmentIcon, null), /*#__PURE__*/_react["default"].createElement("input", {
      multiple: true,
      type: "file",
      ref: uploaderRef,
      onChange: handleUploading
    })), /*#__PURE__*/_react["default"].createElement(_ActionPopup["default"], {
      title: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0444\u0430\u0439\u043B\u044B",
      description: "\u041E\u0431\u044A\u0435\u043C \u0432\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C 10 \u041C\u0411.",
      submitText: "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439",
      isOpen: isAttachmentSizeError,
      onCancel: toggleIsAttachmentSizeError,
      onSubmit: handleSubmitAttachmentError
    }));
  };
  var templateButton = function templateButton() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledOverlayLoader, {
      isLoading: isLoadingMailTemplate,
      styles: messengerFormLoaderStyles
    }, /*#__PURE__*/_react["default"].createElement(StyledToolbarButton, {
      key: "templateButton",
      type: "button",
      onClick: toggleIsOpenTemplateForm
    }, "\u0428\u0430\u0431\u043B\u043E\u043D\u044B")), (0, _size2["default"])(emailTemplateColumns) > 0 && /*#__PURE__*/_react["default"].createElement(_EmailTemplateForm["default"], {
      onClose: toggleIsOpenTemplateForm,
      isOpen: isOpenTemplateForm,
      onSubmit: onSubmitEmailTemplate,
      onSelectGroup: onSelectGroupEmailTemplate,
      onSelectRow: onSelectRowEmailTemplate,
      columns: emailTemplateColumns,
      activeTemplateGroup: emailTemplateGroup
    }));
  };
  var forwardForm = function forwardForm() {
    return /*#__PURE__*/_react["default"].createElement(StyledEmailFields, null, isOpenToolbar && /*#__PURE__*/_react["default"].createElement(StyledSubjectsContainer, null, /*#__PURE__*/_react["default"].createElement(StyledEmail, null, /*#__PURE__*/_react["default"].createElement(StyledParagraph, null, "\u0422\u0435\u043C\u0430"), /*#__PURE__*/_react["default"].createElement(StyledThemeInput, {
      $isBordered: !themeValue,
      placeholder: "\u0422\u0435\u043C\u0430",
      value: themeValue,
      onChange: function onChange(e) {
        return handleThemeChange(e.target.value);
      }
    })), /*#__PURE__*/_react["default"].createElement(StyledEmail, null, /*#__PURE__*/_react["default"].createElement(StyledParagraph, null, "\u041A\u043E\u043C\u0443"), /*#__PURE__*/_react["default"].createElement(_UserSelect["default"], {
      onInputChange: handleEmailInputChange(SuggestTypes.emailsTo),
      onChange: handleSubjectsChange,
      options: subjectSuggestList,
      value: subjects,
      isLoading: isLoadingSuggests,
      isDisabled: isDisabledEmailToSelect,
      isMulti: false,
      isBordered: !(subjects !== null && subjects !== void 0 && subjects.value)
    })), /*#__PURE__*/_react["default"].createElement(StyledEmail, null, /*#__PURE__*/_react["default"].createElement(StyledParagraph, null, "\u041E\u0442 \u041A\u043E\u0433\u043E"), /*#__PURE__*/_react["default"].createElement(StyledFormOverlayLoader, {
      styles: messengerFormLoaderStyles,
      isLoading: isLoading
    }, /*#__PURE__*/_react["default"].createElement(_UserSelect["default"], {
      onChange: onChangeFrom,
      options: fromSuggests,
      value: from || defaultFromSuggest,
      isLoading: isLoadingSuggests,
      isDisabled: isDisabledFromSelect,
      isMulti: false,
      isCreatable: false
    }))), (isOpenSubjectsCopy || !(0, _isEmpty2["default"])(subjectsCopy)) && /*#__PURE__*/_react["default"].createElement(StyledEmail, null, /*#__PURE__*/_react["default"].createElement(StyledParagraph, null, "\u041A\u043E\u043F\u0438\u044F"), /*#__PURE__*/_react["default"].createElement(StyledFormOverlayLoader, {
      styles: messengerFormLoaderStyles,
      isLoading: isLoading
    }, /*#__PURE__*/_react["default"].createElement(_UserSelect["default"], {
      onInputChange: handleEmailInputChange(SuggestTypes.emailsTo),
      onChange: onChangeSubjectsCopy,
      options: subjectSuggestList,
      value: subjectsCopyValue,
      isLoading: isLoadingSuggests,
      isDisabled: isDisabledSubjectCopySelect
    }))), (isOpenSubjectsHideCopy || !(0, _isEmpty2["default"])(subjectsHideCopy)) && /*#__PURE__*/_react["default"].createElement(StyledEmail, null, /*#__PURE__*/_react["default"].createElement(StyledParagraph, null, "\u0421\u043A\u0440\u044B\u0442\u0430\u044F \u043A\u043E\u043F\u0438\u044F"), /*#__PURE__*/_react["default"].createElement(StyledFormOverlayLoader, {
      isLoading: isLoading,
      styles: messengerFormLoaderStyles
    }, /*#__PURE__*/_react["default"].createElement(_UserSelect["default"], {
      onInputChange: handleEmailInputChange(SuggestTypes.emailsTo),
      onChange: onChangeSubjectsHideCopy,
      options: subjectSuggestList,
      value: subjectsHideCopyValue,
      isLoading: isLoadingSuggests,
      isDisabled: isDisabledSubjectHideCopySelect
    }))), !isOpenSubjectsCopy && (0, _isEmpty2["default"])(subjectsCopy) && /*#__PURE__*/_react["default"].createElement(StyledTextButton, {
      type: "button",
      onClick: toggleIsOpenSubjectsCopy
    }, "+ \u041A\u043E\u043F\u0438\u044F"), !isOpenSubjectsHideCopy && (0, _isEmpty2["default"])(subjectsHideCopy) && /*#__PURE__*/_react["default"].createElement(StyledTextButton, {
      type: "button",
      onClick: toggleIsOpenSubjectsHideCopy
    }, "+ \u0421\u043A\u0440\u044B\u0442\u0430\u044F \u043A\u043E\u043F\u0438\u044F")), /*#__PURE__*/_react["default"].createElement(StyledFormOverlayLoader, {
      styles: messengerFormEditorLoaderStyled,
      isLoading: isLoading
    }, /*#__PURE__*/_react["default"].createElement(StyledEditor, {
      toolbarButtons: [linkButton, attachmentButton, templateButton],
      editorId: "messenger-form-email",
      placeholder: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
      outerValue: body,
      disableToolbar: !isOpenToolbar,
      onChange: handleEditorChanges,
      onFocus: handleFocus
    }), isForwardingMessage && /*#__PURE__*/_react["default"].createElement(StyledForwardEditor, {
      disableToolbar: true,
      editorId: "forward-message-form",
      outerValue: forwardingMessageBody,
      onChange: handleForwardEditorChange
    }), isForwardingChain && /*#__PURE__*/_react["default"].createElement(StyledForwardingChainInfo, null, "* \u0431\u0443\u0434\u0435\u0442 \u043F\u0435\u0440\u0435\u0441\u043B\u0430\u043D\u0430 \u0432\u0441\u044F \u0446\u0435\u043F\u043E\u0447\u043A\u0430 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 *")), attachments.length > 0 && /*#__PURE__*/_react["default"].createElement(StyledAttachmentList, {
      onDelete: handleDeleteAttachment,
      list: attachments
    }), isForwardingMessage && /*#__PURE__*/_react["default"].createElement(StyledAttachmentList, {
      isForwarding: true,
      onDelete: handleDeleteForwardAttachment,
      list: forwardAttachments
    }));
  };
  var usualForm = function usualForm() {
    return type === Types.email ? /*#__PURE__*/_react["default"].createElement(StyledEmailFields, null, isOpenToolbar && /*#__PURE__*/_react["default"].createElement(StyledSubjectsContainer, null, /*#__PURE__*/_react["default"].createElement(StyledEmail, null, /*#__PURE__*/_react["default"].createElement(StyledParagraph, null, "\u041A\u043E\u043C\u0443"), /*#__PURE__*/_react["default"].createElement(_UserSelect["default"], {
      onInputChange: handleEmailInputChange(SuggestTypes.emailsTo),
      onChange: handleSubjectsChange,
      options: subjectSuggestList,
      value: subjects,
      isLoading: isLoadingSuggests,
      isDisabled: isDisabledEmailToSelect,
      isMulti: false
    })), /*#__PURE__*/_react["default"].createElement(StyledEmail, null, /*#__PURE__*/_react["default"].createElement(StyledParagraph, null, "\u041E\u0442 \u041A\u043E\u0433\u043E"), /*#__PURE__*/_react["default"].createElement(StyledFormOverlayLoader, {
      styles: messengerFormLoaderStyles,
      isLoading: isLoading
    }, /*#__PURE__*/_react["default"].createElement(_UserSelect["default"], {
      onChange: onChangeFrom,
      options: fromSuggests,
      value: from || defaultFromSuggest,
      isLoading: isLoadingSuggests,
      isDisabled: isDisabledFromSelect,
      isMulti: false,
      isCreatable: false
    }))), (isOpenSubjectsCopy || !(0, _isEmpty2["default"])(subjectsCopy)) && /*#__PURE__*/_react["default"].createElement(StyledEmail, null, /*#__PURE__*/_react["default"].createElement(StyledParagraph, null, "\u041A\u043E\u043F\u0438\u044F"), /*#__PURE__*/_react["default"].createElement(StyledFormOverlayLoader, {
      styles: messengerFormLoaderStyles,
      isLoading: isLoading
    }, /*#__PURE__*/_react["default"].createElement(_UserSelect["default"], {
      onInputChange: handleEmailInputChange(SuggestTypes.emailsTo),
      onChange: onChangeSubjectsCopy,
      options: subjectSuggestList,
      value: subjectsCopyValue,
      isLoading: isLoadingSuggests,
      isDisabled: isDisabledSubjectCopySelect
    }))), (isOpenSubjectsHideCopy || !(0, _isEmpty2["default"])(subjectsHideCopy)) && /*#__PURE__*/_react["default"].createElement(StyledEmail, null, /*#__PURE__*/_react["default"].createElement(StyledParagraph, null, "\u0421\u043A\u0440\u044B\u0442\u0430\u044F \u043A\u043E\u043F\u0438\u044F"), /*#__PURE__*/_react["default"].createElement(StyledFormOverlayLoader, {
      isLoading: isLoading,
      styles: messengerFormLoaderStyles
    }, /*#__PURE__*/_react["default"].createElement(_UserSelect["default"], {
      onInputChange: handleEmailInputChange(SuggestTypes.emailsTo),
      onChange: onChangeSubjectsHideCopy,
      options: subjectSuggestList,
      value: subjectsHideCopyValue,
      isLoading: isLoadingSuggests,
      isDisabled: isDisabledSubjectHideCopySelect
    }))), !isOpenSubjectsCopy && (0, _isEmpty2["default"])(subjectsCopy) && /*#__PURE__*/_react["default"].createElement(StyledTextButton, {
      type: "button",
      onClick: toggleIsOpenSubjectsCopy
    }, "+ \u041A\u043E\u043F\u0438\u044F"), !isOpenSubjectsHideCopy && (0, _isEmpty2["default"])(subjectsHideCopy) && /*#__PURE__*/_react["default"].createElement(StyledTextButton, {
      type: "button",
      onClick: toggleIsOpenSubjectsHideCopy
    }, "+ \u0421\u043A\u0440\u044B\u0442\u0430\u044F \u043A\u043E\u043F\u0438\u044F")), /*#__PURE__*/_react["default"].createElement(StyledFormOverlayLoader, {
      styles: messengerFormEditorLoaderStyled,
      isLoading: isLoading
    }, /*#__PURE__*/_react["default"].createElement(StyledEditor, {
      toolbarButtons: [linkButton, attachmentButton, templateButton],
      editorId: "messenger-form-email",
      placeholder: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
      outerValue: body,
      disableToolbar: !isOpenToolbar,
      onChange: handleEditorChanges,
      onFocus: handleFocus
    })), attachments.length > 0 && /*#__PURE__*/_react["default"].createElement(StyledAttachmentList, {
      onDelete: handleDeleteAttachment,
      list: attachments
    })) : /*#__PURE__*/_react["default"].createElement(StyledEmailFields, null, /*#__PURE__*/_react["default"].createElement(StyledFormOverlayLoader, {
      styles: messengerFormEditorLoaderStyled,
      isLoading: isLoading
    }, /*#__PURE__*/_react["default"].createElement(StyledMessengerFields, null, /*#__PURE__*/_react["default"].createElement(StyledEditor, {
      plain: true,
      disableToolbar: !isOpenToolbar,
      toolbarMarks: [],
      toolbarButtons: [attachmentButton, templateButton],
      placeholder: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
      outerValue: body,
      editorId: "messenger-form-social",
      onFocus: handleFocus,
      onChange: handleEditorChanges
    }))), attachments.length > 0 && /*#__PURE__*/_react["default"].createElement(StyledAttachmentList, {
      onDelete: handleDeleteAttachment,
      list: attachments
    }));
  };
  var SuggestTypes = MessengerForm2.SuggestTypes;
  var submitButtonLabel = isForwardingProcess ? 'Переслать' : buttonLabel;
  return /*#__PURE__*/_react["default"].createElement(StyledMessengerForm, {
    autoComplete: "off",
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    className: className,
    width: width
  }, isOpenToolbar ? /*#__PURE__*/_react["default"].createElement(StyledHideToolbarButton, {
    onClick: toggleToolbar
  }) : /*#__PURE__*/_react["default"].createElement(StyledShowToolbarButton, {
    onClick: toggleToolbar
  }), isForwardingProcess ? forwardForm() : usualForm(), imageUrls && /*#__PURE__*/_react["default"].createElement(StyledAttachmentList, {
    list: imageUrls
  }), /*#__PURE__*/_react["default"].createElement(StyledButtonsWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledSubmitButton, {
    onClick: handleSubmit,
    disabled: isDisabledSubmitButton,
    isLoading: isLoading,
    size: _Button2.Sizes.FLEX
  }, isLoading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledSpinner, null), buttonIsLoadingLabel) : submitButtonLabel), isForwardingProcess && !isLoading && /*#__PURE__*/_react["default"].createElement(StyledCancelButton, {
    onClick: handleCancelForwarding
  }, "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C")));
});
MessengerForm2.SuggestTypes = {
  emailsTo: 'emailsTo',
  emailsFrom: 'emailsFrom'
};
MessengerForm2.propTypes = {
  values: _propTypes["default"].shape({
    body: _propTypes["default"].string,
    imageUrl: _propTypes["default"].string,
    subjects: _propTypes["default"].arrayOf(_UserSelect.ValueType),
    isOpenSubjectsCopy: _propTypes["default"].bool,
    isOpenSubjectsHideCopy: _propTypes["default"].bool
  }),
  buttonLabel: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func,
  onChangeSubjects: _propTypes["default"].func,
  onChangeSubjectsCopy: _propTypes["default"].func,
  onChangeSubjectsHideCopy: _propTypes["default"].func,
  onChangeBody: _propTypes["default"].func,
  onSetForwardingMessage: _propTypes["default"].func,
  onResetForwardingMessage: _propTypes["default"].func,
  // onSetForwardingChain: PropTypes.func,
  onResetForwardingChain: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  type: _propTypes["default"].oneOf(Object.values(Types)),
  fromSuggests: _propTypes["default"].arrayOf(_UserSelect.OptionType),
  defaultFromSuggest: _UserSelect.OptionType,
  subjectSuggestList: _propTypes["default"].arrayOf(_UserSelect.OptionType),
  isDisabledFromSelect: _propTypes["default"].bool,
  isDisabledSubjectSelect: _propTypes["default"].bool,
  isDisabledSubjectCopySelect: _propTypes["default"].bool,
  isDisabledSubjectHideCopySelect: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  isLoadingMailTemplate: _propTypes["default"].bool,
  isLoadingSuggests: _propTypes["default"].bool,
  isDisabledSubmit: _propTypes["default"].bool,
  buttonIsLoadingLabel: _propTypes["default"].string,
  width: _propTypes["default"].string,
  emailTemplateColumns: _propTypes["default"].arrayOf(_EmailTemplateForm.emailTemplateColumnType),
  emailTemplateGroup: _propTypes["default"].string,
  onSubmitEmailTemplate: _propTypes["default"].func,
  onSelectRowEmailTemplate: _propTypes["default"].func,
  onSelectGroupEmailTemplate: Function.prototype,
  className: _propTypes["default"].string,
  from: _UserSelect.ValueType,
  subjectsCopy: _propTypes["default"].arrayOf(_UserSelect.ValueType),
  subjectsHideCopy: _propTypes["default"].arrayOf(_UserSelect.ValueType),
  isForwardingMessage: _propTypes["default"].bool,
  isForwardingChain: _propTypes["default"].bool,
  forwardingMessage: _Message.MessageType,
  forwardingChain: _propTypes["default"].number
};
MessengerForm2.defaultProps = {
  values: {
    subjects: null,
    isOpenSubjectsCopy: false,
    isOpenSubjectsHideCopy: false,
    body: ''
  },
  onSubmit: Function.prototype,
  onFocus: Function.prototype,
  onChangeSubjects: Function.prototype,
  onChangeSubjectsCopy: Function.prototype,
  onChangeSubjectsHideCopy: Function.prototype,
  onChangeBody: Function.prototype,
  type: 'email',
  buttonLabel: 'Отправить',
  buttonIsLoadingLabel: 'Загрузка',
  isLoading: false,
  isLoadingMailTemplate: false,
  isLoadingSuggests: false,
  isDisabledSubmit: false,
  isDisabledFromSelect: false,
  subjectSuggestList: null,
  fromSuggests: null,
  defaultFromSuggest: null,
  isDisabledSubjectSelect: false,
  isDisabledSubjectCopySelect: false,
  isDisabledSubjectHideCopySelect: false,
  width: '340px',
  emailTemplateColumns: [],
  emailTemplateGroup: _EmailTemplateForm.TEMPLATE_GROUPS.COMMON,
  onSubmitEmailTemplate: Function.prototype,
  onSelectRowEmailTemplate: Function.prototype,
  onSelectGroupEmailTemplate: Function.prototype,
  className: '',
  subjectsCopy: null,
  subjectsHideCopy: null
};
MessengerForm2.displayName = 'MessengerForm2';
var StyledForwardingChainInfo = _styledComponents["default"].div.withConfig({
  displayName: "MessengerForm2__StyledForwardingChainInfo",
  componentId: "sc-c9kzit-0"
})(["margin:20px 0;border:1px solid #e1e3e1;width:100%;border-radius:10px;padding:5px 10px;"]);
var StyledEditor = (0, _styledComponents["default"])(_Editor["default"]).withConfig({
  displayName: "MessengerForm2__StyledEditor",
  componentId: "sc-c9kzit-1"
})(["margin-bottom:20px;padding:0;[role='textbox']{max-height:150px;overflow-y:auto;overflow-x:hidden;}"]);
var StyledThemeInput = _styledComponents["default"].input.withConfig({
  displayName: "MessengerForm2__StyledThemeInput",
  componentId: "sc-c9kzit-2"
})(["margin-bottom:6px;border-radius:4px;border:", ";height:38px;padding:10px;width:100%;outline:none;"], function (_ref2) {
  var $isBordered = _ref2.$isBordered;
  return $isBordered ? '1px solid red' : 'none';
});
var StyledForwardEditor = (0, _styledComponents["default"])(StyledEditor).withConfig({
  displayName: "MessengerForm2__StyledForwardEditor",
  componentId: "sc-c9kzit-3"
})(["margin:20px 0;border:1px solid #e1e3e1;width:100%;border-radius:10px;padding:5px 10px;"]);
var StyledMessengerForm = _styledComponents["default"].form.withConfig({
  displayName: "MessengerForm2__StyledMessengerForm",
  componentId: "sc-c9kzit-4"
})(["position:relative;padding:10px;width:", ";background:white;"], function (_ref3) {
  var width = _ref3.width;
  return width;
});
var StyledSubjectsContainer = _styledComponents["default"].div.withConfig({
  displayName: "MessengerForm2__StyledSubjectsContainer",
  componentId: "sc-c9kzit-5"
})(["margin-bottom:10px;position:relative;"]);
var StyledEmailFields = _styledComponents["default"].div.withConfig({
  displayName: "MessengerForm2__StyledEmailFields",
  componentId: "sc-c9kzit-6"
})(["position:relative;overflow:auto;max-height:400px;"]);
var StyledMessengerFields = _styledComponents["default"].div.withConfig({
  displayName: "MessengerForm2__StyledMessengerFields",
  componentId: "sc-c9kzit-7"
})(["position:relative;"]);
var StyledAttachmentIcon = (0, _styledComponents["default"])(_editor.Attachment).withConfig({
  displayName: "MessengerForm2__StyledAttachmentIcon",
  componentId: "sc-c9kzit-8"
})(["width:18px;height:18px;margin-right:2px;> path{stroke:#007aff;}"]);
var StyledToolbarButton = _styledComponents["default"].button.withConfig({
  displayName: "MessengerForm2__StyledToolbarButton",
  componentId: "sc-c9kzit-9"
})(["outline:0;border:none;height:25px;display:flex;color:#007aff;padding:0 5px;cursor:pointer;min-width:25px;font-size:14px;min-height:25px;line-height:24px;overflow:visible;text-align:center;position:relative;border-radius:21px;align-items:center;background:transparent;margin-left:5px;&:hover{color:#179fe3;svg > path{stroke:#179fe3;}}> input{display:none;}"]);
var StyledAttachmentList = (0, _styledComponents["default"])(_AttachmentList["default"]).withConfig({
  displayName: "MessengerForm2__StyledAttachmentList",
  componentId: "sc-c9kzit-10"
})(["margin-bottom:10px;a,span{color:#4d4d4d;font-size:14px;}svg > path{stroke:#4d4d4d;}"]);
var StyledEmail = _styledComponents["default"].div.withConfig({
  displayName: "MessengerForm2__StyledEmail",
  componentId: "sc-c9kzit-11"
})(["display:flex;position:relative;align-items:center;background-color:white;p{margin-right:10px;}"]);
var StyledParagraph = _styledComponents["default"].p.withConfig({
  displayName: "MessengerForm2__StyledParagraph",
  componentId: "sc-c9kzit-12"
})(["width:68px;font-family:'Backpack',sans-serif;font-size:14px;color:#c2c5cc;"]);
var StyledButtonsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MessengerForm2__StyledButtonsWrapper",
  componentId: "sc-c9kzit-13"
})(["display:flex;"]);
var StyledSubmitButton = exports.StyledSubmitButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "MessengerForm2__StyledSubmitButton",
  componentId: "sc-c9kzit-14"
})(["display:flex;align-items:center;justify-content:center;width:186px;color:white;font-weight:bold;border-radius:4px;background-color:", ";cursor:", ";;"], function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? '#c2c5cc' : '#007aff';
}, function (_ref5) {
  var disabled = _ref5.disabled,
    isLoading = _ref5.isLoading;
  return disabled || isLoading ? 'not-allowed' : 'pointer';
});
var StyledCancelButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "MessengerForm2__StyledCancelButton",
  componentId: "sc-c9kzit-15"
})(["margin-left:20px;display:flex;align-items:center;justify-content:center;width:186px;font-weight:bold;border-radius:4px;cursor:'pointer';"]);
var StyledTextButton = _styledComponents["default"].button.withConfig({
  displayName: "MessengerForm2__StyledTextButton",
  componentId: "sc-c9kzit-16"
})(["outline:none;border:none;cursor:pointer;background:transparent;font:14px 'Backpack',sans-serif;color:#007aff;margin-right:10px;&:last-of-type{margin-right:0;}"]);
var StyledSpinner = (0, _styledComponents["default"])(_Throbber["default"]).withConfig({
  displayName: "MessengerForm2__StyledSpinner",
  componentId: "sc-c9kzit-17"
})(["height:20px;width:20px;position:relative;margin:0;left:0;display:inline-block;::before{width:20px;height:20px;bottom:0;top:-1px;position:absolute;}"]);
var StyledOverlayLoader = (0, _styledComponents["default"])(_OverlayLoader["default"]).withConfig({
  displayName: "MessengerForm2__StyledOverlayLoader",
  componentId: "sc-c9kzit-18"
})(["", "{left:5px;}"], _OverlayLoader.StyledBackground);
var StyledFormOverlayLoader = (0, _styledComponents["default"])(_OverlayLoader["default"]).withConfig({
  displayName: "MessengerForm2__StyledFormOverlayLoader",
  componentId: "sc-c9kzit-19"
})(["width:100%;"]);
var StyledHideToolbarButton = (0, _styledComponents["default"])(_iconsReact.Back).withConfig({
  displayName: "MessengerForm2__StyledHideToolbarButton",
  componentId: "sc-c9kzit-20"
})(["position:absolute;cursor:pointer;background:white;box-sizing:border-box;border-radius:5px;top:-20px;left:2px;padding:2px;width:20px;height:20px;fill:#007aff;transform:rotate(-90deg);"]);
var StyledShowToolbarButton = (0, _styledComponents["default"])(StyledHideToolbarButton).withConfig({
  displayName: "MessengerForm2__StyledShowToolbarButton",
  componentId: "sc-c9kzit-21"
})(["transform:rotate(90deg);"]);
var _default = exports["default"] = MessengerForm2;